<div class="search-wrapper" [class.focused]="isDropdownOpen">

    <!-- 左侧：标签列表 + 输入框 -->
    <div class="chips-container">
        <!-- 循环渲染已选标签 -->
        <div class="chip" *ngFor="let item of selectedItems; let i = index">
            <span class="chip-text">{{ item }}</span>
            <span class="chip-remove" (click)="removeItem(i, $event)">
                <!-- SVG X 图标 -->
                <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </span>
        </div>

        <!-- 实际输入框 -->
        <input #inputField *ngIf="selectedItems.length === 0" type="text" class="input-box" [(ngModel)]="inputValue" (focus)="onFocus()"
            (keydown)="onKeyDown($event)" [placeholder]="selectedItems.length === 0 ? placeholder : ''">
    </div>

    <!-- 右侧：功能图标 -->
    <div class="actions">
        <!-- 清除全部按钮 (有内容时显示) -->
        <div class="icon-btn clear-btn" *ngIf="selectedItems.length > 0 || inputValue" (click)="clearAll($event)">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="#adb5bd">
                <path
                    d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
            </svg>
        </div>

        <!-- 搜索按钮 -->
        <div *ngIf="selectedItems.length === 0" class="icon-btn search-btn" (click)="onSearchClick()">
            <i nz-icon nzType="search"></i>
            <!-- <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg> -->
        </div>
    </div>

    <!-- 下拉选单 -->
    <ul class="dropdown-list" *ngIf="isDropdownOpen && selectOptions.length > 0 && selectedItems.length === 0">
        <li *ngFor="let option of selectOptions" (click)="addItem(option); $event.stopPropagation()">
            {{ option.displayName }}
        </li>
    </ul>
</div>